<router-outlet>
  <app-splash-screen></app-splash-screen>
</router-outlet>
<abp-confirmation></abp-confirmation>
